export default "__VITE_ASSET__5q4ZN66q__"